import React from "react";
import RegisterPage, { STATUS_BADGES, StatCard } from "../components/RegisterPage";
import { useHSE } from "../lib/store";

export default function MethodStatement() {
  const { data, siteNames } = useHSE();
  const rows = data.methodStatements || [];
  const approved = rows.filter((r) => r.status === "Approved").length;
  const underReview = rows.filter((r) => r.status === "Under Review").length;
  const linked = (data.riskAssessments || []).map((r) => r.id);

  const Top = (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
      <StatCard label="Total MS" value={rows.length} testid="ms-total" />
      <StatCard label="Approved" value={approved} tone="safe" testid="ms-approved" />
      <StatCard label="Under Review" value={underReview} tone="warning" testid="ms-review" />
      <StatCard label="Draft" value={rows.filter((r) => r.status === "Draft").length} testid="ms-draft" />
    </div>
  );

  return (
    <RegisterPage
      title="Method Statement Register"
      subtitle="Approved work method statements linked to Risk Assessments"
      storeKey="methodStatements"
      idPrefix="MS"
      topPanels={Top}
      columns={[
        { key: "id", label: "MS ID" },
        { key: "activity", label: "Activity" },
        { key: "contractor", label: "Contractor" },
        { key: "site", label: "Site" },
        { key: "linkedRA", label: "Linked RA", render: (r) => r.linkedRA ? <span className="font-mono text-[11px] text-[#2563EB]">{r.linkedRA}</span> : <span className="text-slate-300">—</span> },
        { key: "revision", label: "Revision" },
        { key: "submittedBy", label: "Submitted By" },
        { key: "approvedBy", label: "Approved By" },
        { key: "reviewDate", label: "Review Date" },
        { key: "status", label: "Status" },
      ]}
      badgeMap={{ status: STATUS_BADGES }}
      formFields={[
        { key: "id", label: "MS ID" },
        { key: "activity", label: "Activity" },
        { key: "contractor", label: "Contractor", type: "select", options: data.settings.contractors },
        { key: "site", label: "Site", type: "select", options: siteNames },
        { key: "linkedRA", label: "Linked Risk Assessment", type: "select", options: linked },
        { key: "title", label: "Method Statement Title", full: true },
        { key: "revision", label: "Revision" },
        { key: "submittedBy", label: "Submitted By" },
        { key: "reviewedBy", label: "Reviewed By" },
        { key: "approvedBy", label: "Approved By" },
        { key: "reviewDate", label: "Review Date", type: "date" },
        { key: "status", label: "Status", type: "select", options: ["Draft", "Under Review", "Approved", "Rejected", "Superseded"] },
      ]}
    />
  );
}
